import Choices from 'choices.js';
import { ancestorBySelector } from "../helpers/element/findAncestor";

function createSelect(selectBox) {

  const parentCategories = ancestorBySelector(selectBox, '.product-category-header__categories') !== false;

  if (parentCategories) {
    selectBox.dataset.choiceClasses = "choices--filter choices--cat"
  }

  const choice = new Choices(selectBox, {
    searchEnabled: (selectBox.dataset.choiceSearch === "true") ? true : false,
    itemSelectText: '',
    shouldSort: false,
    shouldSortItems: false,
    classNames: {
      containerOuter: (selectBox.dataset.choiceClasses !== undefined) ? `choices ${selectBox.dataset.choiceClasses}` : 'choices',
    },
  });

  selectBox.choice = choice;

  selectBox.addEventListener('choice', (event) => {

    // Activate Fields
    const parent = ancestorBySelector(selectBox, '.form__field--select');

    if (parent) {
      if (!event.detail.choice.placeholder) {
        parent.classList.add('is-active');
      } else {
        parent.classList.remove('is-active');
      }
    }

    if (selectBox.dataset.type === "filter") {
      const form = document.querySelector('.woocommerce-category-filters');
      const orderby = document.querySelector('[name=orderby]');

      if (form !== null && orderby !== null) {
        orderby.value = event.detail.choice.value;
        form.submit();
      }
    }

    if (parentCategories) {
      location.href = `/product-category/${event.detail.choice.value}`;
    }

  }, false);
}

export function initSelect() {
  const selectBoxes = document.querySelectorAll('.js-select:not(.choices__input)');

  if (selectBoxes.length > 0) {
    selectBoxes.forEach(selectBox => {
      createSelect(selectBox);
    });
  }
}